import type { IHttpConfig } from 'utils/http.old/httpClient.model';
import { getPollingQueueId } from 'utils/streaming/polling/queue';

export default (config: IHttpConfig): IHttpConfig => {
  return {
    ...config,
    headers: {
      ...config.headers,
      'polling-queue-id': getPollingQueueId()!,
    },
  };
};
